import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Utils from '../utils';
import {
  _LOCALE_,
  requestUrls,
  templateUrls
} from './../../../base/vars.js';
import Form from './../../base/form.js';
import Spinner from './../../components/spinner.js';
import { EventHandler } from './../../../base/utils.js';
import CustomValidation from './../../base/custom-validation.js';
import {
  setPiplConsent,
  getPiplConsent,
  removePiplConsent
} from './../../../base/session-handler.js';

export default Backbone.View.extend({
  el: '.app',

  events: {
    'input input': 'handleValidation',
    'change input[type="checkbox"]': 'handleValidation',
    'keyup #username': 'handleUsernameValidation',
    'keyup #password': 'handlePasswordValidation',
    'keyup #confirmPassword': 'handleConfirmPasswordValidation',
    'focus #confirmPassword': 'handleConfirmPasswordValidation',
    'change #separateConsentCheckbox': 'setSeparateConsentCookie',
    'change #acceptTerms': 'acceptTerms',
    'submit': 'onSubmit'
  },

  initialize() {
    Utils.scrollToTop();
    this.model.set('resetPwToken', Utils.getUserAttribute('resetPwToken'));
    this.getTemplate();
  },

  getTemplate() {
    $.ajax({
      url: templateUrls.usernamePassword,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render();
        EventHandler.triggerEvent('username_password', {
          pageName: 'username-password'
        });
        EventHandler.send(EventHandler.lazyLoad.rebind);
        this.handleGdpr();
        this.checkCountry();
      }
    });
  },

  getSecurityQuestions() {
    if (requestUrls && requestUrls['getSecurityQuestions']) {
      $.ajax({
        url: requestUrls['getSecurityQuestions'],
        contentType: 'application/json',
        context: {
          onFail: {
            scrollToElement: $('body'),
            formElement: this.$('form')
          }
        },
        success: (response) => {
          Utils.securityQuestions = response.data;
          Backbone.history.loadUrl('security');
        }
      });
    } else {
      Utils.scrollToTop();
    }
  },

  handleDataPreference() {
    let preferred = $('.gdpr-component #preferred').is(':checked') ? 'Preferred' : 'Unacceptable',
      preferredThirdParty = $('.gdpr-component #preferredThirdParty').is(':checked') ? 'Preferred' : 'Unacceptable';

    Utils.setGdprAttributes('preferences', [{
      PreferLevel: preferred,
      PrefType: 'EmailOffers'
    },
    {
      PreferLevel: preferredThirdParty,
      PrefType: 'ThirdPartyEmailOffers'
    }
    ]);
    this.model.set('optInEmailOffers', $('.gdpr-component #preferred').is(':checked'));
    this.model.set('optInThirdPartyEmailOffers', $('.gdpr-component #preferredThirdParty').is(':checked'));
  },

  onSubmit(e) {
    let isValid = Utils.isValid(this.model),
      options = {
        context: {
          onFail: {
            scrollToElement: $('body'),
            formElement: this.$('form')
          }
        }
      };

    Spinner.appendTo(this.$('form'));
    Form.disableFormField(this.$('.submit'));

    this.handleDataPreference();
    if (requestUrls && requestUrls['onlineAccountSetup'] && isValid) {
      //Cleanup Pipl before submit to enroll
      Utils.deletePiplPayload(this.model);
      this.model.save(null, options)
        .done((response) => {
          Utils.extendUserData(response);
          this.getSecurityQuestions();
        });
    } else {
      Utils.scrollToTop();
      Form.enableFormField(this.$('.submit'));
      Spinner.remove(this.$('form'));
    }
  },

  handleValidation(e) {
    Utils.setBindingAttribute(this.model, e);
    Utils.validateBindingAttribute(this.model, e);
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },

  handlePasswordValidation(e) {
    this.model.set($(e.currentTarget).data('binding'), $(e.currentTarget).val());
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
    CustomValidation.passwordValidation(e.currentTarget);
  },
  handleUsernameValidation(e) {
    this.model.set($(e.currentTarget).data('binding'), $(e.currentTarget).val());
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
    CustomValidation.usernameValidation(e.currentTarget);
  },
  handleConfirmPasswordValidation(e) {
    this.model.set($(e.currentTarget).data('binding'), $(e.currentTarget).val());
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
    CustomValidation.confirmPasswordValidation(e.currentTarget, $('#password').val());
  },

  handleGdpr() {
    let locale = _LOCALE_,
      countryCode = this.model.get('country'),
      $gdpComp = $('.gdpr-container');

    if (locale === 'en-us' && countryCode === 'US') {
      $gdpComp.hide();
    }
    $gdpComp.find('#preferred').prop('checked', this.model.get('optInEmailOffers'));
    $gdpComp.find('#preferredThirdParty').prop('checked', this.model.get('optInThirdPartyEmailOffers'));

    $(document).trigger('gdpr:init');
  },

  checkCountry(){
    const params = new URLSearchParams(window.location.search);
    let countryParams = params.get('country'),
        countryCode = this.model.get('country');
    this.$separateConsent = this.$('.separate-consent-wrapper');
    if((countryCode === 'CN' || countryParams === 'CN')  && !getPiplConsent()){
      this.model.set('SeparateConsent.SeparateConsentCheckbox',true);
      this.$separateConsent.removeClass('hide');
    } else {
      this.$separateConsent.addClass('hide');
      this.model.set('SeparateConsent.SeparateConsentCheckbox',false);
    }
  },

  setSeparateConsentCookie(e){
    let $currentTarget = $(e.currentTarget);
    this.model.set('SeparateConsent.SeparateConsentCheckbox',true);
    if(!$currentTarget[0].checked){
      this.model.unset('SeparateConsent.Pipl');
      this.$($currentTarget).parents('.separate-consent-wrapper').find('.separateConsentCheckbox-error').addClass('show');
      removePiplConsent();
    } else {
      this.model.set('SeparateConsent.Pipl', true);
      this.$($currentTarget).parents('.separate-consent-wrapper').find('.separateConsentCheckbox-error').removeClass('show');
      setPiplConsent($currentTarget[0].checked);
    }

    // Analytics
    if ($currentTarget[0].checked) {
      if (typeof window._satellite !== 'undefined') {
        window._satellite.track('chinaConsent');
      }
    }

    Utils.setBindingAttribute(this.model, e);
    Utils.validateBindingAttribute(this.model, e);
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },

  acceptTerms(e){
    let $currentTarget = $(e.currentTarget);
    console.log($currentTarget);
    if(!$currentTarget[0].checked){
      this.model.unset('acceptTerms');
    } else {
      this.model.set('acceptTerms', true);
    }
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },

  render() {
    this.$el.find('.app-step-container').empty();
    this.$el.html(this.template(_.extend({
      accountNumber: Utils.getUserAttribute('AccountNumber'),
      givenName: Utils.getUserAttribute('firstName')
    }, this.model.toJSON())));
    Utils.nextStep(0);
    $('.submit').attr('disabled', true);
    Utils.bindBackboneValidation(this);
    Utils.triggerFormChecks();
  }
});
